import { createStyles, makeStyles } from "@material-ui/core";

import formatDuration from "src/util/formatDuration";

type Format = "duration" | "number";

const formatters: { [format in Format]: (value: number) => string } = {
  duration: formatDuration,
  number: (value: number) => {
    return value.toLocaleString();
  }
};

const useStyles = makeStyles(theme =>
  createStyles({
    wrapper: {
      maxWidth: "400px",
      margin: "10px 30px"
    },
    value: {
      fontSize: "60px",
      paddingTop: "10px",
      textAlign: "center",
      fontWeight: "bold"
    },
    label: {
      textTransform: "uppercase",
      textAlign: "center",
      color: theme.palette.text.secondary
    }
  })
);

export default function NumberStat({
  format = "number",
  value,
  children
}: {
  format?: "duration" | "number";
  value: number;
  children: React.ReactNode;
}): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.value}>{formatters[format](value)}</div>
      <div className={classes.label}>{children}</div>
    </div>
  );
}
